import { createSelector } from 'reselect';
import { EMPTY_TEXT, Magnetic as Mi } from '@mitchell/react.component.ux';
import { parseJson } from "../../../domain/common";
import { FileUploadStatus } from "../../../domain/file";
import { getVehicleInfoData } from "../../../domain/vehicleInfo";
import { getFoldersOptionList, getIsFolderServiceCompleted, IntelligentPhotoCaptureViewType, PhotoCaptureAssignmentTypes, PhotoCaptureAttributeType, PhotoCaptureMessageConstants, VIN_INVALID_MESSAGE } from "../../../domain/photoCapture";
import { getQuestionnaireEvaluationAnswerDisplayText } from "../../../domain/questionnaireEvaluation";
import { PHOTO_CAPTURE_DEFAULT_ERRORCODE, PHOTO_CAPTURE_DEFAULT_ERRORMSG, PHOTO_CAPTURE_INVALID_VIN_ERRORCODE, PHOTO_CAPTURE_SOMETHING_WENT_WRONG_ERRORCODE, PHOTO_CAPTURE_VIN_DECODE_195000_ERRORCODE, PHOTO_CAPTURE_VIN_DECODE_195001_ERRORCODE, PHOTO_CAPTURE_VIN_DECODE_NETWORK_ERRORCODE, PHOTO_CAPTURE_VIN_DECODE_UNAVAILABLE_ERRORCODE } from '../constants';
import { getUpdatedAttachmentsDamageInfo } from '../utilities';
import { getHasVehicleAttributes } from "../../../domain/vehicleConfigurationAttributes";
const getGPCSource = (state) => state.app.guidedPhotoCapture;
export const getGPCContent = (state) => getGPCSource(state).contentData;
export const getGPCErrorStatus = (state) => getGPCSource(state).isErrorOccured;
export const getGPCLoadingStatus = (state) => getGPCSource(state).isLoading;
export const getGPCInvalidFileUploadInfo = (state) => getGPCSource(state).intelligentFileUploadErrorInfo;
export const getGPCStyle = (state) => getGPCSource(state).styleData;
export const getGPCApplicationContent = (state) => {
    const content = getGPCContent(state);
    return Object.assign(Object.assign({}, content), { headerText: state.domain.photoCapture.assignmentType === PhotoCaptureAssignmentTypes.GENRIC_PHOTO_CAPTURE
            ? content.gpcHeader
            : content.pbeHeader });
};
export const getGPCTheme = createSelector([getGPCStyle, getGPCApplicationContent], (theme, content) => (Object.assign(Object.assign({}, theme), { avatarUrl: theme.avatarImage || EMPTY_TEXT, avatarColor: theme.applicationBackgroundColor || Mi.colorBlack, buttonBackgroundColor: theme.primaryButtonBackgroundColor || Mi.colorRed, buttonTextColor: theme.primaryButtonTextColor || Mi.colorWhite, headerColor: theme.headerTextColor || Mi.colorWhite, thumbsUpColor: theme.thumpsUpGraphicBackgroundColor || Mi.colorGreen05, languageFontColor: theme.languageDropdownTextColor || Mi.colorBlack, languageFontSize: theme.languageFontSize || 14, languageGlobeColor: theme.languageGlobeColor || Mi.colorGreen09, headerText: content.headerText || EMPTY_TEXT, privacyPolicyUrl: content.privacy || EMPTY_TEXT, termsOfUseUrl: content.termsOfUse || EMPTY_TEXT, uploadSuccessfulMessage: content.uploadSuccessfulMessage || EMPTY_TEXT, postUploadRevisitMessage: content.postUploadRevisitMessage || EMPTY_TEXT, redirectionButtonText: content.redirectionButtonText || EMPTY_TEXT, selectShopLandingMessage: content.selectShopLandingMessage || EMPTY_TEXT, shopNotBookedMessage: content.shopNotBookedMessage || EMPTY_TEXT, selectShopBookedMessage: content.selectShopBookedMessage || EMPTY_TEXT })));
export const getAutoRedirectionUrl = createSelector([getGPCApplicationContent], (content) => content.autoRedirectionUrl || '');
export const getGPCAttachmentsFromQuestionnaireEvaluation = createSelector([getQuestionnaireEvaluationAnswerDisplayText], (answerDisplayText) => {
    return parseJson(answerDisplayText) || [];
});
export const getPRGAttachmentsWithDamagesFromQuestionnaire = createSelector([
    getQuestionnaireEvaluationAnswerDisplayText,
    getFoldersOptionList,
    getIsFolderServiceCompleted,
    (state, language) => language
], (answerDisplayText, foldersOptionList, isFolderServiceCompleted, language) => {
    return getUpdatedAttachmentsDamageInfo(parseJson(answerDisplayText) || [], foldersOptionList, isFolderServiceCompleted, language);
});
export const getGPCErrorState = createSelector([getGPCSource], ({ errorState: { errorCode } }) => {
    switch (errorCode) {
        case PHOTO_CAPTURE_DEFAULT_ERRORCODE:
        case PHOTO_CAPTURE_SOMETHING_WENT_WRONG_ERRORCODE: //195004
        case PHOTO_CAPTURE_INVALID_VIN_ERRORCODE: //195005
        case PHOTO_CAPTURE_VIN_DECODE_UNAVAILABLE_ERRORCODE: //195006
        case PHOTO_CAPTURE_VIN_DECODE_195000_ERRORCODE:
        case PHOTO_CAPTURE_VIN_DECODE_195001_ERRORCODE:
            return VIN_INVALID_MESSAGE;
        case PHOTO_CAPTURE_VIN_DECODE_NETWORK_ERRORCODE:
            return PHOTO_CAPTURE_DEFAULT_ERRORMSG;
        default:
            return '';
    }
});
export const shouldHandleFileUploadLoading = ({ isLoading, questionAttributeType, fileInfoData: { uploadStatus }, isRAPFileUploadModalOpen, view = IntelligentPhotoCaptureViewType.NONE }) => {
    switch (questionAttributeType) {
        case PhotoCaptureAttributeType.SUMMARY:
            return false;
        case PhotoCaptureAttributeType.VIDEO_CAPTURE:
            if (uploadStatus === FileUploadStatus.IN_PROGRESS)
                return false;
            break;
        case PhotoCaptureAttributeType.DEFAULT:
            return isRAPFileUploadModalOpen ? false : isLoading;
    }
    return ![
        IntelligentPhotoCaptureViewType.NONE,
        IntelligentPhotoCaptureViewType.PREVIEW,
        IntelligentPhotoCaptureViewType.CAMERA,
        IntelligentPhotoCaptureViewType.VIN_DECODE
    ].includes(view)
        ? false
        : isLoading;
};
export const getShouldRedirectMethod = createSelector([getGPCApplicationContent], (content) => content.redirectionMethod || PhotoCaptureMessageConstants.AUTO);
export const getVINErrorState = (state) => (getGPCSource(state).errorState.error && getGPCSource(state).errorState) || undefined;
export const getIntelligentPhotoCaptureHasVehicleAttributes = (state) => {
    var _a;
    if (getVINErrorState(state)) {
        return false;
    }
    else if (!((_a = getVehicleInfoData(state)) === null || _a === void 0 ? void 0 : _a.Vehicle)) {
        return false;
    }
    else {
        return getHasVehicleAttributes(state);
    }
};
//# sourceMappingURL=getGPCData.js.map